var exports = {
  "K0": "IconButton__GfoErO",
  "rq": "ActionMenu_Overlay__xsk_D8",
  "wi": "Footer__k1rRYh",
};

module.exports = exports;
